// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import "./i18n";
import { ensureGuestId } from "./services/api";
import { LocationProvider } from "./context/LocationContext";

(async () => {
  try {
    await ensureGuestId();
  } catch (e) {
    console.warn("ensureGuestId failed:", e);
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <LocationProvider>
            <App />
          </LocationProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
})();
